<template>
  <div v-if="!themeToggel" class="w-full text-center sticky bottom-0 shadow border bg-white">
    <p>© 2026, Netcore Cloud Pvt. Ltd.</p>
  </div>
  <div v-else class="w-full text-center sticky bottom-0 shadow border dark-bg">
    <p>© 2026, Netcore Cloud Pvt. Ltd.</p>
  </div>
</template>
<script setup>
import { ref, onMounted, watch } from 'vue'
import { useDomainStore } from '@/stores/dashBoardStore.js'

const themeToggel = ref(false)
const domainStore = useDomainStore()

const setLogoOnTheme = () => {
  if (domainStore.theme === 'dark') {
    themeToggel.value = true
  } else {
    themeToggel.value = false
  }
}

watch(
  () => domainStore.theme,
  () => {
    setLogoOnTheme()
  },
)

onMounted(() => {
  setLogoOnTheme()
})
</script>
<style scoped>
.white-bg {
  background-color: white;
}
.dark-bg {
  background-color: rgb(31, 38, 47);
}
</style>
